<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header class="common-header" :title="article_type_name">
                <mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
		<div class="team item">
			<div class="title"><span class="row"></span><span class="span">总业绩</span></div>
			<div class="team-wrapper">
				<div class="team-item">
					<div class="num">{{parseFloat(tg).toFixed(2)}}</div>
					<div class="link"></div>
					<div class="text">销售业绩</div>
				</div>
				<div class="team-item">
					<div class="num">{{tp}}</div>
					<div class="link"></div>
					<div class="text">销售单量</div>
				</div>
				<!--<div class="team-item">
					<div class="num">{{parseFloat(dv).toFixed(2)}}</div>
					<div class="link"></div>
					<div class="text">生态补贴池</div>
				</div>-->
			</div>
		</div>		
        <div class="flex-wrapper" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <div v-for='item in articleList' v-bind:key='item.article_id' @click="goArticleDetail(item)" class="article-class">
                <div class="head">
					<span class="title">{{item.article_title}}</span>
					<span class="but">+ 详情</span>
				</div>
				<span class="info">
					<img :src="item.article_pic"/>
					<div class="body">
						<span class="mask">{{item.article_mask}}</span>
						<span class="sub">
							<span>{{item.article_sub}}</span>
							<span style="text-align: right;">{{item.article_time}}</span>
						</span>						
					</div>					
				</span>				
            </div>
            <empty-record v-if='articleList.length <= 0 && !isMore'></empty-record>
        </div>
    </div>
</template>

<script>
import EmptyRecord from '../../EmptyRecord'
import { Toast, Indicator } from 'mint-ui'
import { getArticleList, getStc} from '../../../api/homeArticle'
export default {
  name: 'ArticleStq',
  components: {     
    EmptyRecord
  },
  data () {
    return {
      article_type_name: '',
	  dv: 0,
	  tg: 0,
	  tp: 0,
      ac_id: 8, // 文章分类ID
      articleList: [],
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true // 是否有更多
    }
  },
  methods: {	
    loadMore () {
      if(this.loading){
        return
      }
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
		this.getStc()
        this.getArticleList(true)
      }
    },
	getStc()
	{
		getStc().then(
		  response => {
		    if (response && response.result) 
			{
		      this.tg = response.result.tg
		      this.tp = response.result.tp
		    }
		  },
		  error => {}
		)
	},
    getArticleList () {
      Indicator.open()
      getArticleList(this.params, this.ac_id).then(res => {
        Indicator.close()
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }

        if (this.articleList) {
          this.articleList = this.articleList.concat(res.result.article_list)
        } else {
          this.articleList = res.result.article_list
        }
        this.article_type_name = res.result.article_type_name
        this.loading = false
      }).catch(error=> {
        Indicator.close()
        Toast(error.message)
        this.loading = false
      })
    },
    goArticleDetail (item) {
      this.$router.push({ 'name': 'HomeArticledetail', 'query': { 'article_id': item.article_id } })
    }
  }
}
</script>

<style scoped lang="scss">
.item{
  		background-color: #fff;
  		//border-radius: .5rem;
  		padding: $pageSpace;
  	  }	
.team{	  
	  .title{
		  margin: 0 0 .75rem;
		  position: relative;
		  overflow: hidden;
		  font-size: .8rem;
		  font-weight: 700;
		  color: #000;
		  display: flex;
		  justify-content: center;
		  align-items: center;
		  height: 1.5rem;
		  .row{
			  display: block;
			   width: 6rem;
			   height: .1rem;
			   background-color: #000;
		  }
		  .span{
			  width: 3.5rem;
			  height: 1.25rem;
			  text-align: center;
			  padding: 0 .5rem;
			  overflow: hidden;
			  background-color: #fff;
			  position: absolute;
			  box-sizing: content-box;
			}
	  }
	  .team-wrapper{
		  display: flex;
		  .team-item{
			  flex: 1 1 0%;
			  justify-content: center;
			  color: #333;
			  display: flex;
			  flex-direction: column;
			  padding: 1.2rem 0;
			  align-items: center;
			  background-color: #fcf3e7;
			  margin:0 .25rem;
			  .num{
				  font-size: .8rem;
				  font-weight: bold;
			  }
			  .link{
				  height: .1rem;
				  width: 1.1rem;
				  background: -webkit-gradient(linear,left top,right top,from(#ecd8be),to(#dbb280));
				  background: linear-gradient(90deg,#ecd8be,#dbb280);
				  margin: .4rem 0;
			  }
			  .text{
				  font-size: .6rem;
			  }
		  }
	  }
 }
.article-class{
	margin:0.2rem;
	padding:0.5rem;		
	background: rgba(255, 255, 255, 1);
	border-radius: 0.1rem;
	font-size:$subFontSize;	
	.head{
		display: flex;
		justify-content: space-between;	
		.title{
			font-weight: bold;
		}
		.but{
			border-radius: 1.5rem;
			background: #f00;
			color:#fff;
			padding:0.1rem 0.6rem;
		}
		margin:0.3rem 0rem;
	}		
	.info{
		display: flex;
		justify-content: flex-start;				
		img{
			width:2.5rem;
			height:2.5rem;
			margin-right: 0.3rem;
			border-radius:50%;		
		}
		.body{
			width:85%;
			.sub{
				display: flex;
				justify-content: space-between;
				font-size: .5rem;
			    color: #ccc;
				margin-top: 0.5rem;
			}
			.mask{
				overflow: hidden;
				text-overflow:ellipsis;
				white-space:nowrap;				
			}
		}		
	}	
}
</style>